import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { findingSortMethod_Alphabet, findingSortMethod_Static, findingSortMethod_Timestamp, findingViewSectionType_FishBone, findingViewType_Sections, sectionRenderMethod_Contained, sectionRenderMethod_Inline } from '@app/advisor-ui-shared';
import { _className, ComponentSync, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { BadImplementationException, sortArray } from '@nu-art/ts-common';
import { ModuleFE_Advisor_FindingView } from '@app/advisor-frontend';
import './Component_FindingView.scss';
import { FadeScrollWrapper, ScrollBar } from '@app/styles';
import { Component_FindingViewSection } from '../Component_FindingViewSection/Component_FindingViewSection.js';
import { ModuleFE_AdvisorAnalytics } from '../../../../../_analytics/consts.js';
export class Component_FindingView extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        if (nextProps.findingView.type !== findingViewType_Sections)
            throw new BadImplementationException('Passed non section finding view');
        state.findingView = nextProps.findingView;
        return state;
    }
    componentDidMount() {
        ModuleFE_AdvisorAnalytics.trigger.uiLoad.uiLoad_findings({
            elapsed_ms: ModuleFE_AdvisorAnalytics.getTimeSinceLoad(),
        });
    }
    //######################### Logic #########################
    getSections = () => {
        const sections = this.state.findingView.sections;
        switch (this.state.findingView.sectionSortMethod) {
            case findingSortMethod_Static:
                return sections;
            case findingSortMethod_Alphabet:
                return sortArray(sections, section => section.label.toLowerCase());
            case findingSortMethod_Timestamp: {
                const timestampMap = [];
                sections.forEach(section => {
                    timestampMap.push({
                        section,
                        timestamp: ModuleFE_Advisor_FindingView.getTimestampForSection(section),
                    });
                });
                sortArray(timestampMap, item => item.timestamp, true);
                return timestampMap.map(item => item.section);
            }
        }
    };
    getContainedSectionRows = (sections) => {
        const rows = [];
        sections.forEach(section => {
            if (!ModuleFE_Advisor_FindingView.isVisible.section(section))
                return;
            //If the section is taking full width or height, push it in a lone row
            if (section.config.spanPanelWidth || section.config.fillPanelHeight)
                return rows.push({ sections: [section], fillHeight: !!section.config.fillPanelHeight });
            const lastRow = rows[rows.length - 1];
            if (!lastRow || lastRow.sections.length > 1)
                return rows.push({ sections: [section], fillHeight: false });
            lastRow.sections.push(section);
        });
        return rows;
    };
    getContainedSectionCardClassName = (section) => {
        return _className('renderer__finding-view__contained__card', section.type, section.config.spanPanelWidth && 'span-width', section.config.fillPanelHeight && 'fill-height');
    };
    //######################### Render #########################
    render() {
        switch (this.state.findingView.sectionRenderMethod) {
            case sectionRenderMethod_Inline:
                return this.renderSections_Inline();
            case sectionRenderMethod_Contained:
                return this.renderSections_Contained();
            default:
                this.logError(`Missing implementation for section render method ${this.state.findingView.sectionRenderMethod}`);
                return _jsx(_Fragment, {});
        }
    }
    //######################### Render - Inline #########################
    renderSections_Inline = () => {
        const sections = this.getSections();
        return _jsx(LL_V_L, { className: 'renderer__finding-view__inline', children: sections.map(section => _jsx(Component_FindingViewSection, { section: section, hideSectionLabel: sections.length === 1 }, section.label)) });
    };
    //######################### Render - Contained #########################
    renderSections_Contained = () => {
        const sections = this.getSections();
        const sectionRows = this.getContainedSectionRows(sections);
        return _jsx(LL_V_L, { className: 'renderer__finding-view__contained', children: sectionRows.map((row, index) => {
                const rowClassName = _className('renderer__finding-view__contained__row', row.fillHeight && 'fill-height');
                return _jsx(LL_H_C, { className: rowClassName, children: row.sections.map(section => {
                        switch (section.type) {
                            case findingViewSectionType_FishBone:
                                return _jsx(LL_H_C, { className: this.getContainedSectionCardClassName(section), children: _jsxs(LL_V_L, { className: 'renderer__finding-view__contained__card-main', children: [_jsx("div", { className: 'renderer__finding-view__contained__card-label', children: section.label }), _jsx(Component_FindingViewSection, { section: section, hideSectionLabel: true }, section.label)] }) }, section.label);
                            default: {
                                const scrollRef = React.createRef();
                                return _jsxs(LL_H_C, { className: this.getContainedSectionCardClassName(section), children: [_jsxs(LL_V_L, { className: 'renderer__finding-view__contained__card-main', children: [_jsx("div", { className: 'renderer__finding-view__contained__card-label', children: section.label }), _jsx(FadeScrollWrapper, { scrollRef: scrollRef, children: _jsx(Component_FindingViewSection, { section: section, hideSectionLabel: true }) })] }), _jsx(ScrollBar, { scrollableRef: scrollRef })] }, section.label);
                            }
                        }
                    }) }, index);
            }) });
    };
}
//# sourceMappingURL=Component_FindingView.js.map